import React, { useState } from "react";
import { useMessageSource } from "react-message-source";
import SignatoryDropdownFieldContainer from "../../../ui/layout/page/forms-container/form-item-container/signatory-dropdown-container";
import DropdownField from "../../shared/components/formik/dropdown";
import Person from "../person";
import { PersonType, SetNameAndSignatureType } from "../types";
import { SignatoryType } from "../../../api/cybwell/types";
import { SelectChangeEvent } from "@mui/material";

export default function SignatoryDropDown({
  name,
  signatories,
  selectedSignatory = {} as PersonType,
  setNameAndSignatureType,
  onSelect,
}: {
  name: string;
  signatories?: SignatoryType[];
  selectedSignatory: PersonType;
  setNameAndSignatureType: SetNameAndSignatureType;
  onSelect?: (selectedSignature: SignatoryType) => void;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  const [isFirstNameLabelShrunk, setIsFirstNameLabelShrunk] =
    useState<boolean>(false);
  const [isLastNameLabelShrunk, setIsLastNameLabelShrunk] =
    useState<boolean>(false);

  const signatoriesMap = signatories
    ? signatories.reduce(
        (acc, obj) => ({ ...acc, ...{ [obj.id]: obj } }),
        {} as { [key: string]: SignatoryType },
      )
    : {};

  const onSelectCallback = (
    e: SelectChangeEvent<string | number | string[]>,
  ) => {
    const id = e.target.value as string;
    setNameAndSignatureType(
      `${name}.`,
      signatoriesMap[id].firstName,
      signatoriesMap[id].lastName,
      signatoriesMap[id].signatureType,
    );

    setIsFirstNameLabelShrunk(true);
    setIsLastNameLabelShrunk(true);

    if (onSelect) {
      onSelect(signatoriesMap[id]);
    }
  };

  return (
    signatories &&
    signatories.length > 0 && (
      <>
        <SignatoryDropdownFieldContainer>
          <DropdownField
            name={`${name}.cybwellId`}
            menuItems={signatories.map((item: SignatoryType) => ({
              value: item ? item.id : "",
              children: item ? `${item.firstName} ${item.lastName}` : "",
              disabled: item.disabled,
            }))}
            selectedItemValue={
              selectedSignatory ? selectedSignatory.cybwellId : ""
            }
            label={getMessage("DropdownOptions.default")}
            onSelectCallback={onSelectCallback}
          />
        </SignatoryDropdownFieldContainer>
        <Person
          shrinkFirstNameLabel={isFirstNameLabelShrunk}
          handleShrinkFirstNameLabel={() => {
            setIsFirstNameLabelShrunk(false);
          }}
          shrinkLastNameLabel={isLastNameLabelShrunk}
          handleShrinkLastNameLabel={() => {
            setIsLastNameLabelShrunk(false);
          }}
          {...selectedSignatory}
          dataPath={`${name}.`}
        />
      </>
    )
  );
}
